<template>
  <div class="index-churchs">
    <div class="page-title">
      <PageTitle
        class="page-home-title"
        isBack="true"
        link="home"
        fontSize="25"
        icon="fa fa-cube"
        title="Igrejas"
      />
    </div>
    <b-row class="m-3 row-line">
      <!-- <b-button size="lg" variant="primary" @click="clickImport()">Importar Igrejas e Pastores</b-button>
      <div class="space"></div>-->
      <b-button size="lg" variant="primary" @click="clickDownloadXLSChurchs()">Exportar Igrejas</b-button>
      <div class="space"></div>
      <b-button size="lg" variant="primary" @click="clickDownloadXLSPastor()">Exportar Pastores</b-button>
    </b-row>
    <!-- <vs-popup
      fullscreen
      title="Exportação das Igrejas"
      @close="onClose"
      :active.sync="myPopUpRefPrint"
    >
      <div class="content-modal">
        <b-table striped hover bordered :items="items"></b-table>
      </div>
    </vs-popup>-->
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { baseApiOnlineBible } from "@/global";
import { BTable } from "bootstrap-vue";
import PageTitle from "@/components/template/PageTitle";
import XLSX from "xlsx";

export default {
  components: {
    BTable,
    PageTitle,
  },
  data() {
    return {
      myPopUpRefPrint: false,
      linkPrint: "",
      items: [],
      USER_TOKEN: "",
    };
  },
  mounted() {
    // this.getToken();
  },
  methods: {
    // async getToken() {
    //   await axios
    //     .post(`${baseApiOnlineBibleAuth}/login`, {
    //       username: "api.acms",
    //       password: "WEylogP21R6I5LoyrLv1",
    //     })
    //     .then((resp) => {
    //       console.log(resp.data);
    //       this.USER_TOKEN = resp.data;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    // async clickImport() {
    //   this.$vs.loading();
    //   await axios
    //     .get(`${baseApiOnlineBible}/import/associations`)
    //     .then((resp) => {
    //       this.showMessage(resp.data.message, "success");
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });

    //   this.$vs.loading.close();
    // },
    showMessage(message, type) {
      this.$vs.notify({
        title: "Aviso",
        text: message,
        color: type,
      });
    },
    async clickDownloadXLSPastor() {
      this.$vs.loading();
      // const AuthStr = "Bearer ".concat(this.USER_TOKEN);
      this.items = await axios
        .get(`${baseApiOnlineBible}/view/pastors`)
        .then((resp) => resp.data.object);
      const data = XLSX.utils.json_to_sheet(this.items);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, "pastors.xlsx");
      this.$vs.loading.close();
    },
    async clickDownloadXLSChurchs() {
      this.$vs.loading();
      // const AuthStr = "Bearer ".concat(this.USER_TOKEN);
      let items2 = await axios
        .get(`${baseApiOnlineBible}/view/associations`)
        .then((resp) => resp.data.object);
      const data = XLSX.utils.json_to_sheet(items2);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, "churchs.xlsx");
      this.$vs.loading.close();
    },
    // async clickDownloadXLSChurchs() {
    //   this.$vs.loading();
    //   const AuthStr = "Bearer ".concat(this.USER_TOKEN);
    //   let resultByte = await axios
    //     .get(`${baseApiOnlineBible}/report/xls`)
    //     .then((resp) => resp.data);
    //   console.log(resultByte);
    //   let bytes = this.base64ToArrayBuffer(resultByte);
    //   this.saveByteArray(bytes);
    //   this.$vs.loading.close();
    // },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(byte) {
      var blob = new Blob([byte], { type: "application/octet-binary" });
      let url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "churchs.xlsx");
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>

<style scoped src="./churchs.css"></style>
